module.exports = __webpack_public_path__ + "static/media/pers-2.30c62a90.jpg";